import './RadioGroup.scss';

/** Radio button group form control used to select a value out an array of options. */
export const RadioGroup = ({
  label,
  name,
  onValueChange,
  options,
  value
}) => {
  return (
    <div className="radio-group">
      <label className="control-label" htmlFor={name}>{label}</label>
      <div className="radio-options">
        {options.map((option) =>
          <label className="radio-option" key={option.label}>
            <input
              type="radio"
              checked={option.value === value}
              onChange={() => onValueChange(option.value)}
            />
            {option.label}
          </label>
        )}
      </div>
    </div>
  );
};
